import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
	connect() {
		this.element.selectionStart = this.element.selectionEnd = this.element.value.length
	}
}
